import { useLoader } from 'Store/loader';
import LoaderPrimary from './loaderPrimary';

const Loader = () => {
  const { variant } = useLoader();

  const obj = {
    'loader-primary': <LoaderPrimary />,
  };

  return obj[variant] || <></>;
};

export default Loader;
